

let initialState = {
    comments: []
};

function comments(state = initialState, action) {

    if (action.type === "COMMENT_ADD") {
        console.log("reduce comment: "+JSON.stringify(action.comment));
        console.log("reduce comments: "+JSON.stringify(state.comments));
        return {
            ...state,
            comments: state.comments.concat( action.comment )
        }


    } else if (action.type === "COMMENT_REMOVE"){
        return {
            ...state,
            comments: state.comments.filter(comment => comment.id !== action.id)
        }
    } else if (action.type === "COMMENT_REMOVE_ALL"){
        return {
            ...state,
            comments: []
        }
    } else if (action.type === "COMMENT_UPDATE"){
    
        const index = state.comments.findIndex(i => i.id === action.comment.id)
        return {
            ...state,
            comments:[...state.comments.slice(0,index), 
                action.comment,
                ...state.comments.slice(1+index)]

        }
    }

    return state;
}


export default comments;